<template>
  <div class="MyOrder">
    <!-- 1. 顶部订单状态切换 Tab 胶囊条 -->
    <div class="order-tabs-bar">
      <div
        v-for="(item, index) in tagList"
        :key="'tag' + index"
        class="tab-pill"
        :class="{ 'is-active': form_head_uuid === item.form_head_uuid }"
        @click="changeIndex(item.form_head_uuid)"
      >
        <span>{{ item.name }}</span>
      </div>
    </div>

    <!-- 2. 审批中心列表（当属于特定审批form_head_uuid时呈现） -->
    <template v-if="show">
      <ApprovalList
        v-if="
          [
            '403e15205bc248f48d8a3626571c4e56',
            '91e9bb4eac0a48b38e8327cc9c6c23de',
            '33d336e546644de7afb25e1989757d93'
          ].includes(form_head_uuid)
        "
        form_id="436ae44d1c60475a9b4009ca40edc11e"
        :form_head_uuid="form_head_uuid"
      />

      <!-- 3. 常规订单列表区域 -->
      <template v-else>
        <!-- 态 1：骨架屏加载态 (彻底消除 Tab 切换或初次加载时的空插画闪现) -->
        <div class="order-skeleton-list" v-if="orderLoading">
          <div class="skeleton-order-card" v-for="n in 3" :key="'sk-' + n">
            <div class="skeleton-shimmer"></div>
            <div class="sk-card-header">
              <div class="sk-line sk-time"></div>
              <div class="sk-line sk-orderno"></div>
              <div class="sk-line sk-status-pill"></div>
            </div>
            <div class="sk-card-body">
              <div class="sk-thumb"></div>
              <div class="sk-info">
                <div class="sk-line sk-name"></div>
                <div class="sk-line sk-spec"></div>
              </div>
              <div class="sk-price"></div>
            </div>
          </div>
        </div>

        <!-- 态 2：真实订单卡片列表 -->
        <div class="order-box-container fade-in" v-else-if="orderList && orderList.length > 0">
          <div class="order-table-header">
            <span class="col-goods">物资信息与规格</span>
            <span class="col-price">协议单价</span>
            <span class="col-num">采购数量</span>
            <span class="col-total">小计金额</span>
            <span class="col-status">状态</span>
          </div>

          <ul class="order-card-list">
            <li v-for="item in orderList" :key="'order-' + item.id" class="order-card-item">
              <!-- 订单卡片头部 -->
              <div class="card-header-bar">
                <div class="header-left">
                  <span class="order-date">
                    <i class="el-icon-date"></i> {{ item.l0u3cwjsdrbnhuth }}
                  </span>
                  <span class="order-no font-mono">
                    订单号：<strong>{{ item['5rh34ajk852uufsx'] }}</strong>
                  </span>
                </div>
                <div class="header-right">
                  <span class="order-contract-tip">
                    <i class="el-icon-circle-check"></i> 框架协议入库品
                  </span>
                </div>
              </div>

              <!-- 订单内商品子表条目 -->
              <div class="card-goods-body">
                <div
                  class="goods-row-item"
                  v-for="(order, idx) in item.cpimejxmehpaxrrz"
                  :key="idx"
                >
                  <div class="col-goods">
                    <div class="thumb-wrap" @click.stop="order.whfmbyuc1i2pavi4 && order.whfmbyuc1i2pavi4.length && navTo('/mall/goods/' + order.whfmbyuc1i2pavi4[0].id)">
                      <img
                        :src="
                          order.mnkt8dkjryhvdej3 && order.mnkt8dkjryhvdej3.length > 0
                            ? order.mnkt8dkjryhvdej3[0].url
                            : ''
                        "
                        alt="商品图"
                        class="thumb-img"
                      />
                    </div>
                    <div class="goods-meta-box">
                      <p
                        class="goods-title"
                        @click.stop="order.whfmbyuc1i2pavi4 && order.whfmbyuc1i2pavi4.length && navTo('/mall/goods/' + order.whfmbyuc1i2pavi4[0].id)"
                        v-if="order.whfmbyuc1i2pavi4 && order.whfmbyuc1i2pavi4.length > 0"
                      >
                        {{ order.whfmbyuc1i2pavi4[0].value }}
                      </p>
                    </div>
                  </div>

                  <span class="col-price font-mono">
                    ¥ {{ formatMoney(order.rojkudmmvpzinpar) }}
                  </span>

                  <span class="col-num font-mono">
                    {{ order.mcuilzaudpe3shlc }} {{ order.kq1qbbk7dulmlghs ? `(${order.kq1qbbk7dulmlghs})` : '' }}
                  </span>

                  <span class="col-total font-mono">
                    ¥ {{ formatMoney(order.nvbfzg88gv88hnt9) }}
                  </span>

                  <!-- 状态图标回显 -->
                  <div class="col-status" v-if="idx === 0">
                    <span class="status-badge dfh" v-if="item.skwyvudrzzk6oljg === '6773a3b6-26c8-41d9-a2fe-26d73f0fa8f8'">待发货</span>
                    <span class="status-badge ysh" v-else-if="item.skwyvudrzzk6oljg === 'ed990658-9190-491e-bc87-8311a7dcb31c'">已发货</span>
                    <span class="status-badge shz" v-else-if="item.skwyvudrzzk6oljg === 'a84d211b-2bc0-4c24-8a45-01fc249e5a5a'">审核中</span>
                    <span class="status-badge dsh" v-else-if="item.skwyvudrzzk6oljg === '1c10fa79-0b9d-4892-9be8-03daad9ffe8b'">待收货</span>
                    <span class="status-badge ywc" v-else-if="item.skwyvudrzzk6oljg === '898c47e2-acdc-41a7-b63b-c42cc1eda346'">已完成</span>
                    <span class="status-badge yqx" v-else-if="item.skwyvudrzzk6oljg === 'b2434af8-3618-4a37-aeb2-55aea65f3bb6'">已取消</span>
                    <span class="status-badge spz" v-else-if="item.lzmpjqms8ynktnxi === '02c5ca9e-3252-456e-8d51-6ff370f4b2c8'">审批中</span>
                    <span class="status-badge spcg" v-else-if="item.lzmpjqms8ynktnxi === 'bf8f4aa2-016c-488f-9732-5ab12d354d69'">审批成功</span>
                    <span class="status-badge sphb" v-else-if="item.skwyvudrzzk6oljg === '657f2655-9bde-4ca5-a0a1-1f7c4aa93a43'">审核失败</span>
                  </div>
                  <div class="col-status" v-else></div>
                </div>
                <div v-if="item.orderDetailLoading" class="order-detail-state">
                  正在加载订单明细...
                </div>
                <div
                  v-else-if="!item.cpimejxmehpaxrrz || item.cpimejxmehpaxrrz.length === 0"
                  class="order-detail-state"
                >
                  未查询到商品明细
                </div>
              </div>

              <!-- 订单卡片底部汇总与业务操作 -->
              <div class="card-footer-bar">
                <div class="footer-left">
                  <span class="tax-tag">含 13% 增值税专用发票</span>
                  <div class="total-wrap">
                    <span class="total-label">订单应付总额：</span>
                    <span class="total-price font-mono">¥ {{ formatMoney(item.p6zxciihiw61mebe) }}</span>
                  </div>
                </div>

                <div class="footer-actions">
                  <!-- 重新发起审核 -->
                  <el-button
                    size="small"
                    type="warning"
                    plain
                    v-if="item.lzmpjqms8ynktnxi === '8abf497b-d388-4ea5-a2f2-2813578853f9'"
                    @click="initiateAudit(item)"
                  >
                    发起审核
                  </el-button>

                  <!-- 确认收货 -->
                  <el-button
                    size="small"
                    type="primary"
                    v-if="item.skwyvudrzzk6oljg === '1c10fa79-0b9d-4892-9be8-03daad9ffe8b'"
                    @click="confirmReceiptGoods(item)"
                  >
                    确认收货
                  </el-button>

                  <!-- 退换货申请 -->
                  <template v-if="item.skwyvudrzzk6oljg === '898c47e2-acdc-41a7-b63b-c42cc1eda346'">
                    <el-button
                      size="small"
                      v-if="
                        item.b8lqe9bvzid6twwc !== 'f16a9ec4-ef71-4b9c-aa85-f02d1b440226' &&
                        (item.aliweixqekq3uo2s !== '8ef31faf-5153-4fd4-ab5e-2b6599ce8d64' ||
                         item.kgwambu2gnj2clcn === 'fa090b14-a3ee-4eac-89c2-32cfc12c5619')
                      "
                      @click="navTo(`/mall/orderDetail/${item.id}?type=returnGoods`)"
                    >
                      申请退货
                    </el-button>
                    <el-button
                      size="small"
                      @click="navTo(`/mall/orderDetail/${item.id}?type=barter`)"
                      v-if="
                        item.aliweixqekq3uo2s !== '8ef31faf-5153-4fd4-ab5e-2b6599ce8d64' &&
                        item.b8lqe9bvzid6twwc !== 'f16a9ec4-ef71-4b9c-aa85-f02d1b440226'
                      "
                    >
                      申请换货
                    </el-button>
                  </template>

                  <!-- 取消订单 -->
                  <el-button
                    size="small"
                    v-if="
                      [
                        'a84d211b-2bc0-4c24-8a45-01fc249e5a5a',
                        'ed990658-9190-491e-bc87-8311a7dcb31c',
                        '657f2655-9bde-4ca5-a0a1-1f7c4aa93a43'
                      ].includes(item.skwyvudrzzk6oljg)
                    "
                    @click="cancelAnOrder(item)"
                  >
                    取消订单
                  </el-button>

                  <!-- 查看详情 -->
                  <el-button size="small" type="primary" plain @click="viewOrderDetail(item)">
                    查看详情
                  </el-button>
                </div>
              </div>
            </li>
          </ul>

          <!-- 分页控件 -->
          <div class="pagination-wrapper">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[10, 20, 40, 80]"
              :page-size="limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>

        <!-- 态 3：规范空状态卡片 (仅当非加载态且确实无数据时才展示) -->
        <div class="empty-order-card fade-in" v-else>
          <div class="empty-icon-wrap">
            <i class="el-icon-document-remove"></i>
          </div>
          <h3 class="empty-title">暂无相关采购订单</h3>
          <p class="empty-desc">当前分类下未检索到符合条件的订单记录，可前往协议目录选购所需物料。</p>
          <button class="empty-action-btn" @click="$router.push('/mall/show/goodsList/1/all')" type="button">
            <span>浏览协议商品</span>
            <i class="el-icon-arrow-right"></i>
          </button>
        </div>
      </template>
    </template>

    <el-dialog
      title="订单详情"
      :visible.sync="orderDetailVisible"
      width="min(1100px, 92vw)"
      top="5vh"
      :close-on-click-modal="true"
      :destroy-on-close="true"
      custom-class="order-detail-dialog"
      @closed="selectedOrderId = ''"
    >
      <OrderDetail
        v-if="orderDetailVisible && selectedOrderId"
        :key="selectedOrderId"
        :order-id="selectedOrderId"
        embedded
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Popup from "../../components/Popup";
import OrderDetail from "./OrderDetail.vue";
import { online, children, execButton, getFormRowApproveList, setApproveClose } from "@/api/platform";
import ApprovalList from '@/components/ApprovalList.vue';

export default {
  name: "MyOrder",
  components: {
    Popup,
    OrderDetail,
    ApprovalList,
  },
  computed: {
    ...mapState(["clientToken"]),
  },
  data () {
    return {
      orderLoading: true,
      tagList: [
        { name: "全部订单", form_head_uuid: "58a2be48484e436dbbb28fd778406de6" },
        { name: "审核中", form_head_uuid: "403e15205bc248f48d8a3626571c4e56" },
        { name: "审核成功", form_head_uuid: "91e9bb4eac0a48b38e8327cc9c6c23de" },
        { name: "审核失败", form_head_uuid: "33d336e546644de7afb25e1989757d93" },
        { name: "待发货", form_head_uuid: "42c3b2c71c83420095614efde43e4cea" },
        { name: "待收货", form_head_uuid: "7713093266f64911bb3ef4b14c58affc" },
        { name: "已完成", form_head_uuid: "e9667bbbf7d942cea48e531fd58b7142" },
        { name: "已取消", form_head_uuid: "255520d9ab374cb3b40b4dcef1b0d1a2" },
      ],
      form_head_uuid: "58a2be48484e436dbbb28fd778406de6",
      orderList: [],
      page: 1,
      total: 0,
      limit: 20,
      show: true,
      orderRequestId: 0,
      orderDetailVisible: false,
      selectedOrderId: '',
    };
  },
  mounted () {
    this.getOrderList();
  },
  methods: {
    formatMoney (val) {
      if (val === null || val === undefined || val === '') return '0.00';
      const num = Number(val);
      return Number.isFinite(num) ? num.toFixed(2) : String(val);
    },
    // 获取订单列表
    async getOrderList () {
      const requestId = ++this.orderRequestId;
      this.orderLoading = true;
      const { form_head_uuid, page, limit } = this;
      try {
        const { meta, result } = await online({
          form_head_uuid,
          page,
          limit,
          keyword: "",
          select_option: "",
        });
        if (requestId !== this.orderRequestId) return;

        const list = Array.isArray(result) ? result : [];
        this.orderList = list.map((el) => ({
          ...el,
          cpimejxmehpaxrrz: [],
          orderDetailLoading: true,
        }));
        this.total = (meta && meta.total) || 0;
        this.orderLoading = false;

        // 父订单先展示；单条明细失败或延迟不得阻塞整页状态收敛。
        this.orderLoading = false;
        await Promise.all(list.map(async (el) => {
          const details = await this.children(el.id);
          if (requestId !== this.orderRequestId) return;

          const index = this.orderList.findIndex((item) => item.id === el.id);
          if (index === -1) return;
          this.$set(this.orderList, index, {
            ...this.orderList[index],
            cpimejxmehpaxrrz: details,
            orderDetailLoading: false,
          });
        }));
      } catch (error) {
        if (requestId !== this.orderRequestId) return;
        this.orderList = [];
        this.total = 0;
      } finally {
        if (requestId === this.orderRequestId) {
          this.orderLoading = false;
        }
      }
    },
    // 获取子表数据
    async children (record_id) {
      try {
        const { form_head_uuid } = this;
        const { result } = await children({
          page: 1,
          limit: 100,
          field_uuid: "00f98dceac054e8fb727092a99fc5a3d",
          form_head_uuid,
          record_id,
        });
        return result || [];
      } catch (error) {
        return [];
      }
    },
    handleCurrentChange (page) {
      this.page = page;
      this.getOrderList();
    },
    handleSizeChange (limit) {
      this.page = 1;
      this.limit = limit;
      this.getOrderList();
    },
    changeIndex (form_head_uuid) {
      this.page = 1;
      this.form_head_uuid = form_head_uuid;

      if (['403e15205bc248f48d8a3626571c4e56', '91e9bb4eac0a48b38e8327cc9c6c23de', '33d336e546644de7afb25e1989757d93'].includes(form_head_uuid)) {
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 300);
      } else {
        this.show = true;
        this.getOrderList();
      }
    },
    navTo (route) {
      this.$router.push(route);
      this.$store.commit('setData', {
        form_head_uuid: this.form_head_uuid,
      });
    },
    viewOrderDetail ({ id }) {
      if (!id) return;
      this.selectedOrderId = id;
      this.orderDetailVisible = true;
    },
    // 确认收货
    async confirmReceiptGoods ({ id }) {
      await execButton({
        button_uuid: "ab6a5764-7f39-43d9-b4f9-6d47a3ea30b8",
        form_head_uuid: "7713093266f64911bb3ef4b14c58affc",
        id,
        type: 2,
      });
      this.page = 1;
      this.$notify({
        title: "提示",
        message: "确认收货成功",
        type: "success",
      });
      setTimeout(() => {
        this.getOrderList();
      }, 1500);
    },
    initiateAudit ({ id }) {
      this.$confirm("确认要重新发起审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        await execButton({
          button_uuid: "e5740381-1dae-49c4-aaa9-5f35f8df10c6",
          form_head_uuid: "7713093266f64911bb3ef4b14c58affc",
          id,
          type: 2,
        });
        this.$notify({
          title: "提示",
          message: "发起成功",
          type: "success",
        });
        this.page = 1;
        setTimeout(() => {
          this.getOrderList();
        }, 1500);
      }).catch(() => { });
    },
    // 取消订单
    cancelAnOrder ({ id }) {
      this.$confirm("确认要取消该订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        await execButton({
          button_uuid: "7b388e44-8bfb-4fb7-b312-a03a1bca2369",
          form_head_uuid: this.form_head_uuid,
          id,
          type: 2,
        });
        this.$notify({
          title: "提示",
          message: "取消订单成功",
          type: "success",
        });
        setTimeout(() => {
          this.getOrderList();
          this.getFormRowApproveList(id);
        }, 1500);
      }).catch(() => { });
    },
    async getFormRowApproveList (form_row_uuid) {
      try {
        const { result } = await getFormRowApproveList({
          applicationid: '270ab0c29e5411ee9b8b0242321230b4',
          form_uuid: '436ae44d1c60475a9b4009ca40edc11e',
          form_row_uuid,
        });
        if (result && result.data && result.data.list && result.data.list.length > 0) {
          this.setApproveClose(result.data.list[0].id);
        }
      } catch (e) {}
    },
    async setApproveClose (approve_id) {
      try {
        await setApproveClose({
          approve_id,
          id: '270ab0c29e5411ee9b8b0242321230b4',
        });
      } catch (e) {}
    },
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';

.MyOrder {
  width: 100%;

  // 1. 顶部 Tab 条
  .order-tabs-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #ffffff;
    border: 1px solid @brandBorder;
    border-radius: 8px;
    padding: 8px 12px;
    margin-bottom: 16px;
    overflow-x: auto;

    .tab-pill {
      padding: 7px 16px;
      font-size: 13px;
      font-weight: 500;
      color: @brandTextLight;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.15s ease;
      white-space: nowrap;

      &:hover {
        color: @brandPrimary;
        background-color: #f8fafc;
      }

      &.is-active {
        background-color: @brandPrimary;
        color: #ffffff;
        font-weight: 600;
        box-shadow: 0 2px 6px rgba(15, 82, 186, 0.25);
      }
    }
  }

  // 2. 骨架屏加载态
  .order-skeleton-list {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .skeleton-order-card {
      background-color: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 10px;
      padding: 18px;
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      gap: 14px;

      .sk-card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 12px;
        border-bottom: 1px solid #f1f5f9;

        .sk-time { width: 140px; height: 16px; }
        .sk-orderno { width: 220px; height: 16px; }
        .sk-status-pill { width: 70px; height: 22px; }
      }

      .sk-card-body {
        display: flex;
        align-items: center;
        gap: 16px;

        .sk-thumb {
          width: 64px;
          height: 64px;
          background-color: #f1f5f9;
          border-radius: 6px;
          flex-shrink: 0;
        }

        .sk-info {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 8px;

          .sk-name { width: 60%; height: 16px; }
          .sk-spec { width: 30%; height: 14px; }
        }

        .sk-price {
          width: 100px;
          height: 20px;
          background-color: #f1f5f9;
          border-radius: 4px;
        }
      }

      .sk-line {
        background-color: #f1f5f9;
        border-radius: 4px;
      }
    }
  }

  // 3. 真实订单卡片
  .order-box-container {
    .order-table-header {
      display: flex;
      align-items: center;
      height: 40px;
      background-color: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 6px;
      padding: 0 16px;
      font-size: 13px;
      font-weight: 600;
      color: @brandTextLight;
      margin-bottom: 12px;

      .col-goods { flex: 1; min-width: 320px; }
      .col-price { width: 130px; text-align: center; }
      .col-num { width: 110px; text-align: center; }
      .col-total { width: 130px; text-align: center; }
      .col-status { width: 110px; text-align: center; }
    }

    .order-card-list {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      gap: 16px;

      .order-card-item {
        background-color: #ffffff;
        border: 1px solid @brandBorder;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0, 40, 100, 0.02);
        transition: border-color 0.15s ease, box-shadow 0.15s ease;

        &:hover {
          border-color: rgba(15, 82, 186, 0.3);
          box-shadow: 0 4px 14px rgba(0, 40, 100, 0.05);
        }

        // 订单卡片头部
        .card-header-bar {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background-color: #f8fafc;
          border-bottom: 1px solid #e2e8f0;
          padding: 10px 18px;
          font-size: 12px;

          .header-left {
            display: flex;
            align-items: center;
            gap: 18px;

            .order-date {
              color: @brandTextLight;
              display: flex;
              align-items: center;
              gap: 4px;
            }

            .order-no {
              color: @brandTextDark;

              strong {
                color: @brandPrimary;
                letter-spacing: 0.5px;
              }
            }
          }

          .header-right {
            .order-contract-tip {
              color: #10b981;
              font-weight: 500;
              display: flex;
              align-items: center;
              gap: 4px;
            }
          }
        }

        // 订单商品内容区
        .card-goods-body {
          padding: 0 18px;

          .order-detail-state {
            padding: 22px 0;
            color: @brandTextLight;
            font-size: 13px;
            text-align: center;
          }

          .goods-row-item {
            display: flex;
            align-items: center;
            padding: 16px 0;
            border-bottom: 1px solid #f1f5f9;

            &:last-child {
              border-bottom: none;
            }

            .col-goods {
              flex: 1;
              min-width: 320px;
              display: flex;
              align-items: center;
              gap: 14px;

              .thumb-wrap {
                width: 60px;
                height: 60px;
                border: 1px solid #e2e8f0;
                border-radius: 6px;
                padding: 4px;
                background-color: #ffffff;
                cursor: pointer;
                flex-shrink: 0;

                .thumb-img {
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                  mix-blend-mode: multiply;
                }
              }

              .goods-meta-box {
                .goods-title {
                  font-size: 13px;
                  font-weight: 500;
                  color: @brandTextDark;
                  line-height: 1.4;
                  margin: 0;
                  cursor: pointer;

                  &:hover {
                    color: @brandPrimary;
                    text-decoration: underline;
                  }
                }
              }
            }

            .col-price {
              width: 130px;
              text-align: center;
              font-size: 13px;
              color: @brandTextDark;
            }

            .col-num {
              width: 110px;
              text-align: center;
              font-size: 13px;
              color: @brandTextLight;
            }

            .col-total {
              width: 130px;
              text-align: center;
              font-size: 14px;
              font-weight: 600;
              color: @brandTextDark;
            }

            .col-status {
              width: 110px;
              text-align: center;

              .status-badge {
                display: inline-block;
                padding: 2px 8px;
                border-radius: 4px;
                font-size: 11px;
                font-weight: 600;

                &.dfh { background-color: #fef3c7; color: #d97706; }
                &.ysh { background-color: #e0f2fe; color: #0284c7; }
                &.shz { background-color: #f1f5f9; color: #475569; }
                &.dsh { background-color: #eff6ff; color: #2563eb; }
                &.ywc { background-color: #ecfdf5; color: #059669; }
                &.yqx { background-color: #f1f5f9; color: #94a3b8; }
                &.spz { background-color: #eff6ff; color: #3b82f6; }
                &.spcg { background-color: #ecfdf5; color: #10b981; }
                &.sphb { background-color: #fee2e2; color: #ef4444; }
              }
            }
          }
        }

        // 订单卡片底部结算
        .card-footer-bar {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background-color: #fcfdfe;
          border-top: 1px solid #f1f5f9;
          padding: 12px 18px;

          .footer-left {
            display: flex;
            align-items: center;
            gap: 16px;

            .tax-tag {
              font-size: 11px;
              color: #64748b;
              background-color: #f1f5f9;
              padding: 2px 6px;
              border-radius: 4px;
            }

            .total-wrap {
              font-size: 13px;
              color: @brandTextDark;

              .total-price {
                font-size: 17px;
                font-weight: 700;
                color: @brandPrimary;
              }
            }
          }

          .footer-actions {
            display: flex;
            align-items: center;
            gap: 8px;
          }
        }
      }
    }

    .pagination-wrapper {
      display: flex;
      justify-content: flex-end;
      margin-top: 24px;
      padding: 12px 0;

      /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: @brandPrimary;
        color: #ffffff;
      }
    }
  }

  // 4. 空状态卡片
  .empty-order-card {
    background-color: #ffffff;
    border: 1px solid @brandBorder;
    border-radius: 10px;
    padding: 60px 20px;
    text-align: center;
    margin: 20px 0;

    .empty-icon-wrap {
      width: 56px;
      height: 56px;
      background-color: #f1f5f9;
      color: #94a3b8;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 26px;
      margin: 0 auto 14px;
    }

    .empty-title {
      font-size: 15px;
      font-weight: 700;
      color: @brandTextDark;
      margin: 0 0 6px;
    }

    .empty-desc {
      font-size: 13px;
      color: @brandTextLight;
      max-width: 400px;
      margin: 0 auto 20px;
      line-height: 1.5;
    }

    .empty-action-btn {
      height: 36px;
      padding: 0 20px;
      background-color: @brandPrimary;
      color: #ffffff;
      font-size: 13px;
      font-weight: 600;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      transition: background 0.15s ease;

      &:hover {
        background-color: @brandContainer;
      }
    }
  }

  .skeleton-shimmer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(241, 245, 249, 0.75) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    transform: translateX(-100%);
    animation: shimmerMove 1.5s infinite;
    pointer-events: none;
    z-index: 2;
  }
}

.fade-in {
  animation: fadeIn 0.35s ease forwards;
}

@keyframes shimmerMove {
  100% {
    transform: translateX(100%);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/client/MyOrder.vue